export const apiKey = `TEz8bLzgzyTfqGDFWwyAy8cEuuLuCWu0`;
export const qty = `15`;
export const autoQty = `5`;
export const urlSearch = `https://api.giphy.com/v1/gifs/search`;
export const urlTrending = `https://api.giphy.com/v1/gifs/trending`;
export const urlAutoComplete = `https://api.giphy.com/v1/gifs/search/tags`;

export const way = {
    DAY: "MODO DIURNO",
    NIGHT: "MODO NOCTURNO"
};

export const make = {
    before: "Realiza tu búsqueda",
    after: "Resultados de la búsqueda"
}